import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { UserService } from '../auth/service/user.service';
import { HelperService } from './helper.service';

@Injectable({
  providedIn: 'root',
})
export class UpgradeService {
  currentUser: any = null;
  constructor(
    private router: Router,
    private userService: UserService,
    private helperService: HelperService
  ) {
    this.userService.userData.subscribe((userData) => {
      if (userData) {
        this.currentUser = userData;
      } else {
        this.currentUser = null;
      }
    });
  }

  onAskPro(level?: string) {
    if (!level) {
      level = 'lite';
    }
    let txt = '';
    if (level == 'lite') {
      txt = 'This requires a lite or pro account.  Would you like to upgrade?';
      // txt = 'This requires a pro account.  Would you like to upgrade?';
    }
    if (level == 'pro') {
      txt = 'This requires a pro account.  Would you like to upgrade?';
    }
    Swal.fire({
      title: 'Upgrade your account?',
      text: txt,
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value == true) {
        this.helperService.closeAllModals();
        if (this.currentUser.role_id == 2) {
          this.router.navigate(['/subscribe']);
        } else {
          this.router.navigate(['/manage-subscription']);
        }
      } else {
      }
    });
  }

  checkPro(level?: string) {
    if (!level) {
      level = 'lite';
    }

    let showBadge = false;
    if (this.currentUser && this.currentUser.role_id) {
      if (
        this.currentUser.role_id == 2 ||
        (level == 'pro' && this.currentUser.role_id == 3)
      ) {
        showBadge = true;
      }
    }
    return showBadge;
  }
}
